export class AppliedBulkRejection {
  numRejected: number;
  numRemaining: number;
  rejectionCategory: string;
  rejectionReason: string;
  rejectionType: string;
}
